import React from 'react';
import { getTableColumns } from 'helpers';
import { FasHistory } from 'assets/icons';
// import atoms from 'ctsutheme/components/atoms';
// import { CanUserAuditCohorts } from 'appconstants/Permission';

// const { IconButton, Typography } = atoms;

const RemainingColumns =  [['description', 'string', 'Description', 'left', true],
['status', 'string', 'Status', 'left', true],
['statusDate', 'string', 'Status Date', 'left', true],
['statusReason', 'string', 'Reason', 'left', true],
['accrualTarget', 'string', 'Accrual Target', 'left', true],
['currentAccrual', 'string', 'Current Accrual', 'left', true],
['reservedSlot', 'string', 'Reserved Slots', 'left', true]
]
const CohortsArmManagementColumns = [
{
  name: 'cohortName',
    type: 'string',
    label: 'Cohort',
    align: 'left',
    sort: true,
    renderCell : (data, rowInfo) =>   {
    return(<>
        <button
              type="button"
              className="fn-btn font-lg mr-1 ml-1"
              data-id="stratum"
              onClick={(e) => rowInfo[0](e, data)}
            >
              <FasHistory />
            </button>
      <span style={{ marginRight: '1rem' }}>
       {data.cohortName}
     </span>
     </>
    )
    }
    
},
  ...getTableColumns(RemainingColumns)
  ];
  
  
  export default CohortsArmManagementColumns;
  